import CardCarousel from 'components/Content/NavigationCarousel/CardCarousel/CardCarousel';

export default CardCarousel;
